<template>
  <div>
    <el-card>
      <div class="d-flex">
        <div class="side-frame-success"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            Bill No：{{
              formData.techCuttingNo ? formData.techCuttingNo : 'New'
            }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <b-badge
            style="font-size: 12px"
            :variant="
              formData.techCuttingStatus === 'S'
                ? 'success'
                : formData.techCuttingStatus === 'D'
                ? 'danger'
                : 'primary'
            "
          >
            {{ formData.v_techCuttingStatus }}
          </b-badge>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
            at
            {{ formData.modifyTime ? formData.modifyTime : '--' }}
          </span>
          <!-- <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName ? formData.createByName : '--' }} at
          {{ formData.createTime ? formData.createTime : '--' }}
        </span> -->
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Review：{{ formData.reviewByName ? formData.reviewByName : '--' }}
            at
            {{ formData.reviewTime ? formData.reviewTime : '--' }}
          </span>
        </div>
      </div>
      <div class="d-flex">
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.order_form_label_custOrderNo') || '客户订单编号' }}：{{
              formData.custOrderNo ? formData.custOrderNo : '--'
            }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.order_form_label_salesPersonCode') || '业务人员' }}：{{
              formData.salesPersonName ? formData.salesPersonName : '--'
            }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.order_form_label_custCode') || '下单客户' }}：{{
              formData.custName ? formData.custName : '--'
            }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.order_form_label_endCustCode') || '终端客户' }}：{{
              formData.endCustName ? formData.endCustName : '--'
            }}
          </span>
        </div>
      </div>
    </el-card>
    <el-card class="mt-2">
      <CuttingInfoDetail
        :techCuttingCode="formData.techCuttingCode"
        :orderCode="formData.orderCode"
        :disabled="disabled"
      />
    </el-card>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import CuttingInfoDetail from './cutting-info-detail'

export default {
  components: { CuttingInfoDetail },
  mixins: [EditLoading],
  props: {
    techCuttingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      productLineParams: { dictType: 'productLine' },
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.formData = {}
      if (!this.techCuttingCode) return
      this.$api
        .techCuttingInfoDetailApi({
          techCuttingCode: this.techCuttingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result)
        return this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )

      this.loadingOpen()
      let saveApi = {}
      if (this.techCuttingCode) {
        saveApi = this.$api.techCuttingInfoEditSaveApi(this.formData)
      } else {
        saveApi = this.$api.techCuttingInfoAddSaveApi(this.formData)
      }
      saveApi
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.techCuttingCode) {
            this.$router.replace({
              name: 'technology-techGoodsCutting-detail',
              params: { code: res.body, pageType: 'edit' },
            })
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
